module.exports = __webpack_public_path__ + "static/media/ME_Project-Special-topic-presentation_template.55c31c10.ppt";